import type { Resource } from "i18next";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export enum AppLang {
    RU = "ru",
    EN = "en"
}

const i18nResource: Resource = {};
const t = i18n;
console.log(t);
i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    //.use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        lng:
            process.env.NODE_ENV === "development"
                ? window.navigator.language
                : AppLang.RU,
        debug: process.env.NODE_ENV === "development",
        fallbackLng: Object.values(AppLang),
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        resources: i18nResource,
    });

export default i18n;
